/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type GrammarList } from '../conditionalSearch/grammar.type';
import {
    FileSystems,
    HostGroups,
    HOSTs,
    LogicalPorts,
    LUNGroups,
    LUNs,
    LUNSnapshots,
    PortGroups,
    vStores,
} from './en-US';
import { batch, grammar } from './gammar';

const keyMap = {
    LUNs,
    LUNGroups,
    Namespaces: LUNs,
    NamespaceGroups: LUNGroups,
    Hosts: HOSTs,
    HostGroups,
    PortGroups,
    LogicalPorts,
    vStores,
    LUNSnapshots,
    FileSystems,
};
const grammarList: GrammarList = batch(grammar, keyMap);
export default grammarList;
